import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { LoadingOptions } from '@ionic/core';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  private count = 0;
  private presented: Promise<any>;

  constructor(
    private loader: LoadingController
  ) { }

  wrap(callback: () => any | Promise<any> | Observable<any>, opts?: LoadingOptions) {

    const done = () => {
      this.count -= 1;
      if (this.count > 0 || !this.presented)
        return Promise.resolve(false);

      return this.presented
        .then(() => this.loader.getTop())
        .then(x => x ? this.loader.dismiss() : false);
    }

    if (this.count++ === 0) {
      this.presented = this.loader.create(opts).then(x => x.present());
    }

    try {
      const result = callback();
      if (result && typeof result.then == 'function') {
        // if it's a promise
        return result.then(
          (x: any) => done()
            .then(
              () => x),
          (x: any) => done()
            .then(
              () => {
                throw x;
              })
        );
      } else if (result && typeof result.pipe == 'function') {
        return result.pipe(
          tap(x => done()),
          catchError(err => {
            done();
            throw err;
          })
        )
      }
      else {
        done();
        return result;
      }
    } catch (err) {
      done();
      throw err;
    }
  }
}
